import { useEffect, useState } from "react";
import { CITIES } from "@/lib/brand";

const VERTICALS = [
  {
    tag: "DDJAY · DTCP · HUDA",
    title: "Residential Plots",
    desc: "Geo-targeted campaigns for plotted developments — from licensed colonies in Sonipat to township plots in Jaipur, Khatu Shyam and Sohna.",
    imgs: [
      "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=900&q=70&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1500076656116-558758c991c1?w=900&q=70&auto=format&fit=crop",
    ],
  },
  {
    tag: "TOWERS · GATED COMMUNITIES",
    title: "High-Rise Apartments",
    desc: "Gurugram, Noida and Mumbai sky-scrapers — performance ads, NRI funnels and influencer walkthroughs that fill towers floor by floor.",
    imgs: [
      "https://images.unsplash.com/photo-1486325212027-8081e485255e?w=900&q=70&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=900&q=70&auto=format&fit=crop",
    ],
  },
  {
    tag: "INDEPENDENT · LOW-RISE",
    title: "Builder Floors",
    desc: "Delhi's premium colonies — Punjabi Bagh, Vasant Kunj, Greater Kailash, Faridabad. Polished creative, hyperlocal targeting, end-user-focused funnels.",
    imgs: [
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=70&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1613977257363-707ba9348227?w=900&q=70&auto=format&fit=crop",
    ],
  },
  {
    tag: "PRE-LEASED · SCO · RETAIL",
    title: "Commercial & Office",
    desc: "Cyber City, BKC, Dholera, ORR — investor-grade decks, virtual tours and HNI lead-gen for offices, SCO plots and high-street retail.",
    imgs: [
      "https://images.unsplash.com/photo-1497366216548-37526070297c?w=900&q=70&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=900&q=70&auto=format&fit=crop",
    ],
  },
  {
    tag: "HIMACHAL · UTTARAKHAND · GOA",
    title: "Second Homes & Villas",
    desc: "Lifestyle-led storytelling for weekend homes in Kasauli, Mussoorie, Rishikesh and Goa villas. Targeted at Delhi / Mumbai / Bangalore HNIs.",
    imgs: [
      "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=900&q=70&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=900&q=70&auto=format&fit=crop",
    ],
  },
  {
    tag: "MANAGED FARMS · ORCHARDS",
    title: "Farmland & Agricultural",
    desc: "Investment-grade managed farms in Naugaon, Sohna, Kotputli, Karjat and Nashik — passive-income narrative, escrow trust signals, walkthrough films.",
    imgs: [
      "https://images.unsplash.com/photo-1500595046743-cd271d694d30?w=900&q=70&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=900&q=70&auto=format&fit=crop",
    ],
  },
  {
    tag: "LOGISTICS PARKS · IT PARKS",
    title: "Industrial & Warehousing",
    desc: "B2B inbound for industrial land, Grade-A warehousing in Bhiwadi, NH-48, Bhiwandi — LinkedIn ABM + sales-enablement decks.",
    imgs: [
      "https://images.unsplash.com/photo-1553413077-190dd305871c?w=900&q=70&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=900&q=70&auto=format&fit=crop",
    ],
  },
  {
    tag: "PRE-LAUNCH · BULK DEALS",
    title: "Freehold Land Parcels",
    desc: "Discreet HNI & family-office outreach for clean-title freehold parcels — strategic land banks in Lucknow, Dholera and Dubai corridors.",
    imgs: [
      "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?w=900&q=70&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1604014237800-1c9102c219da?w=900&q=70&auto=format&fit=crop",
    ],
  },
];

const MARQUEE = ["Plots", "Floors", "Towers", "Farmland", "Commercial", "Sold-Out"];

function ImageSlider({ images, alt }) {
  const [active, setActive] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setActive((i) => (i + 1) % images.length), 3500);
    return () => clearInterval(t);
  }, [images.length]);
  return (
    <div className="absolute inset-0">
      {images.map((src, i) => (
        <img
          key={i}
          src={src}
          alt={alt}
          loading="lazy"
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
            i === active ? "opacity-50" : "opacity-0"
          }`}
        />
      ))}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a0b08] via-[#0a0b08]/40 to-transparent" />
      {/* Slider dots */}
      <div className="absolute top-4 right-4 flex gap-1.5">
        {images.map((_, i) => (
          <span
            key={i}
            className={`h-1 rounded-full transition-all ${i === active ? "w-5 bg-[#d4ff4f]" : "w-2 bg-white/40"}`}
          />
        ))}
      </div>
    </div>
  );
}

export default function Verticals() {
  return (
    <section id="verticals" data-testid="verticals-section" className="relative py-24 sm:py-32 border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-10">
          <div>
            <div className="font-mono text-xs text-[#d4ff4f] mb-3 tracking-[0.2em]">#हर_ज़मीन_हर_छत</div>
            <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40 mb-4">/ What we market</div>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.95]">
              Every Indian property<br />
              vertical. <span className="italic text-[#d4ff4f]">One agency.</span>
            </h2>
          </div>
          <p className="max-w-md text-white/60 text-base leading-relaxed">
            From plotted developments in Sonipat to sky-scrapers in Gurugram — we've marketed every kind of inventory that gets bought, leased or invested in across India and beyond.
          </p>
        </div>

        {/* City strip */}
        <div className="mb-14 rounded-2xl border border-white/10 bg-white/[0.02] p-5" data-testid="verticals-cities">
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#d4ff4f] mb-3">/ Where we've delivered bookings</div>
          <div className="flex flex-wrap gap-2">
            {CITIES.map((c, i) => (
              <span
                key={c}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#d4ff4f]/5 border border-[#d4ff4f]/20 text-sm text-white/80 hover:bg-[#d4ff4f] hover:text-black transition cursor-default"
                style={{ animation: `fadeInUp .6s ease-out ${i * 0.04}s both` }}
              >
                <span className="w-1.5 h-1.5 rounded-full bg-[#d4ff4f]" />
                {c}
              </span>
            ))}
            <span className="inline-flex items-center px-3 py-1.5 rounded-full text-sm text-white/40 font-mono">+ more</span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {VERTICALS.map((v, i) => (
            <article
              key={i}
              data-testid={`vertical-card-${i}`}
              className="card-hover relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.02] aspect-[3/4] group"
            >
              <ImageSlider images={v.imgs} alt={v.title} />
              <div className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-[0.2em] text-white/70">{String(i + 1).padStart(2, "0")} / 08</div>
              <div className="absolute inset-x-0 bottom-0 p-5">
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#d4ff4f] mb-2">{v.tag}</div>
                <h3 className="font-display text-2xl tracking-tight mb-2">{v.title}</h3>
                <p className="text-xs text-white/60 leading-relaxed line-clamp-3 group-hover:line-clamp-none transition-all">{v.desc}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-16 overflow-hidden border-y border-white/10 py-6">
          <div className="marquee gap-12">
            {[...Array(4)].map((_, k) =>
              MARQUEE.map((m, i) => (
                <span key={`${k}-${i}`} className="font-display text-3xl md:text-5xl tracking-tighter text-white/60 inline-flex items-center gap-12 pr-12">
                  {m} <span className="text-[#d4ff4f]">•</span>
                </span>
              ))
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
